__turbopack_context__.v({
  "activeStep": "stopwatch-story-module__-rMf0q__activeStep",
  "deviceColumn": "stopwatch-story-module__-rMf0q__deviceColumn",
  "dynamicIsland": "stopwatch-story-module__-rMf0q__dynamicIsland",
  "homeIndicator": "stopwatch-story-module__-rMf0q__homeIndicator",
  "narrative": "stopwatch-story-module__-rMf0q__narrative",
  "phone": "stopwatch-story-module__-rMf0q__phone",
  "phoneChrome": "stopwatch-story-module__-rMf0q__phoneChrome",
  "phoneLogo": "stopwatch-story-module__-rMf0q__phoneLogo",
  "phoneMenu": "stopwatch-story-module__-rMf0q__phoneMenu",
  "phoneScreen": "stopwatch-story-module__-rMf0q__phoneScreen",
  "phoneViewport": "stopwatch-story-module__-rMf0q__phoneViewport",
  "sideButtonBottom": "stopwatch-story-module__-rMf0q__sideButtonBottom",
  "sideButtonMiddle": "stopwatch-story-module__-rMf0q__sideButtonMiddle",
  "sideButtonTop": "stopwatch-story-module__-rMf0q__sideButtonTop",
  "step": "stopwatch-story-module__-rMf0q__step",
  "stepContent": "stopwatch-story-module__-rMf0q__stepContent",
  "stepDescription": "stopwatch-story-module__-rMf0q__stepDescription",
  "stepDetail": "stopwatch-story-module__-rMf0q__stepDetail",
  "stepEyebrow": "stopwatch-story-module__-rMf0q__stepEyebrow",
  "stepList": "stopwatch-story-module__-rMf0q__stepList",
  "stepProgress": "stopwatch-story-module__-rMf0q__stepProgress",
  "stepTitle": "stopwatch-story-module__-rMf0q__stepTitle",
  "story": "stopwatch-story-module__-rMf0q__story",
  "story-target-rhythm": "stopwatch-story-module__-rMf0q__story-target-rhythm",
  "tryInstruction": "stopwatch-story-module__-rMf0q__tryInstruction",
  "tryInstructions": "stopwatch-story-module__-rMf0q__tryInstructions",
});
